<template>
  <div id="testimonials">
    <div class="container">
      <div class="section-title">
        <h2>Our Testimonials</h2>
        <p>
          We take our Motto "We Care, We serve" seriously.
          <br />
          Here are a few people who loved their experience at Poyanil Hospital.
        </p>
      </div>

      <section class="circle-1">
        <TestimonialSwipers />
      </section>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import TestimonialSwipers from '@/components/HospitalsHomePage/TestimonialsSwipers.vue';

export default defineComponent({
  components: { TestimonialSwipers },
});
</script>

<style scoped>
.section-title {
  margin-bottom: 60px;
  padding-left: 30px;
  position: relative;
  text-align: center;
}

#testimonials {
  margin-top: 100px;
}

#testimonials {
  background-color: #f1f1f1;
  padding-top: 60px;
  padding-bottom: 80px;
}
</style>
